import { getIsDisconnected } from 'state/app/app.slice';
import { useAppSelector } from 'state/store';

export const useBottomBar = () => {
    const isDisconnected = useAppSelector(getIsDisconnected);

    return { isDisconnected };
};
